<template>
	<div>
		<a-modal title="选择文件" :width="998" :isPrivate="isPrivate" :visible="visible"  @cancel="handleCancel" @ok="handleOk"  v-dragModal>
			<div class="toolbar">
				<div class="box-wrap">
					<div class="group-box">
						<ul class="group-list">
							<li title="全部" :class="[curGroupId == -1 ? 'active' : '']"><a class="group-name" @click="handleChangeGroup(-1)" href="javascript:void(0);">全部</a></li>
							<li title="未分组" :class="[curGroupId == 0 ? 'active' : '']"><a class="group-name" @click="handleChangeGroup(0)" href="javascript:void(0);">未分组</a></li>
							<li v-for="(item,index) in groupList" :key="index" :class="[curGroupId == item.group_id ? 'active' : '']">
								<a class="group-operate group-edit" href="javascript:;" @click="edit(item)" title="编辑分组">
									<i class="iconfont ft12 iconedit"></i>
								</a>
								<span @click="handleChangeGroup(item.group_id)">{{item.group_name}}</span>
								<a class="group-delete" href="javascript:;" @click="del(item)" title="删除分组">
									<i class="iconfont ft12 icondelete"></i>
								</a>
							</li>
						</ul>
						<a class="group-operate group-add" href="javascript:;" @click="add()" title="新增分组">新增分组</a>
					</div>
					<div class="file-box">
						<div class="filter-tool">
							<div class="tool-box flex">
								<span class="select-num">已选择 <b>{{Object.keys(curSelectedList).length}}</b> 张图片</span>
								<a class="del delete-btn" href="javascript:void(0);" @click="delFiles()">
									<i class="iconfont ft12 icondelete"></i>
									<span>删除</span>
								</a>
								<a-select class="group-select ml10" v-model="moveGroupId" style="width: 120px" @change="handleMoveGroup" placeholder="移动至">
									<a-select-option :value="0">移动至</a-select-option>
									<a-select-option v-for="(item,index) in groupList" :key="index" :value="item.group_id">{{item.group_name}}</a-select-option>
								</a-select>
							</div>
							<div>
								<a-upload name="file" :show-upload-list="false"
									:customRequest="upload" :beforeUpload="beforeUpload">
                                    <a-button class="upload-btn">
                                        <a-icon :type="loading ? 'loading' : 'upload'" />
                                        上传文件
                                    </a-button>
								</a-upload>
							</div>
						</div>
						<div class="file-list-box">
							<div class="ant-empty ant-empty-normal" v-if="fileList.length > 0 ? false : true">
								<a-empty type="empty" />
							</div>
							<ul class="file-list"
								v-infinite-scroll="handleInfiniteOnLoad"
								:infinite-scroll-disabled="busy"
								:infinite-scroll-distance="10"
								>
								<li  v-for="(item,index) in fileList" :key="index" @click="selected(item, index)">
									<div class="img-cover" v-if="item.file_type=='video' && !item.is_private">
										<video width="100%" height="100%" style="object-fit: cover;">
											<source :src="item.file_path" type="video/mp4" >
										</video>
										<div class="file-icon">
											<a target="_blank" :href="item.file_path"><a-icon type="play-circle" /></a>
										</div>
									</div>
									<div class="img-cover" v-if="item.file_type=='video' && item.is_private">
										<a-icon class="font-icon" type="video-camera" />
										<div class="file-icon"><a-icon @click.stop="previewFile(item)" type="play-circle" /></div>
									</div>
									<div class="img-cover" :style="{'background-image': 'url('+item.file_path+')'}"  v-if="item.file_type=='image' && !item.is_private"></div>
									<div class="img-cover file-cover" v-if="item.file_type=='image' && item.is_private">
										<a-icon class="font-icon" type="file-image" />
										<div class="file-icon"><a-icon @click.stop="previewFile(item)" type="eye" /></div>
									</div>
									<div class="img-cover file-cover" v-if="item.file_type=='file'">
										<a-icon v-if="item.extension.toLowerCase() =='docx'" class="font-icon" type="file-word" />
										<a-icon v-if="item.extension.toLowerCase() =='doc'" class="font-icon" type="file-word" />
										<a-icon v-if="item.extension.toLowerCase() =='pdf'" class="font-icon" type="file-pdf" />
										<a-icon v-if="item.extension.toLowerCase() =='zip'" class="font-icon" type="file-zip" />
										<a-icon v-if="item.extension.toLowerCase() =='rar'" class="font-icon" type="file-zip" />
										<a-icon v-if="item.extension.toLowerCase() =='xls'" class="font-icon" type="file-excel" />
										<a-icon v-if="item.extension.toLowerCase() =='xlsx'" class="font-icon" type="file-excel" />
										<a-icon v-if="item.extension.toLowerCase() =='csv'" class="font-icon" type="file-excel" />
										<a-icon v-if="item.extension.toLowerCase() =='ppt'" class="font-icon" type="file-ppt" />
										<a-icon v-if="item.extension.toLowerCase() =='pptx'" class="font-icon" type="file-ppt" />
										<div class="file-icon" v-if="iconTypeList.indexOf(item.extension.toLowerCase()) > -1">
											<a-icon v-if="item.extension.toLowerCase() =='docx'" @click.stop="previewWord(item)" type="file-word" />
											<a-icon v-if="item.extension.toLowerCase() =='doc'" @click.stop="previewWord(item)"  type="file-word" />
											<a-icon v-if="item.extension.toLowerCase() =='pdf'" @click.stop="previewFile(item)"  type="file-pdf" />
										</div>
									</div>
									<div>{{ item.original_name }}</div>
									<div class="select-mask" v-if="item.selected">
										<a-icon type="check" :style="{margin:'0 auto', fontSize:'60px',color:'#fff'}" />
									</div>
								</li>
							</ul>
							<div class="loading-more" v-if="scrollLoading"><a-spin class="demo-loading" />加载更多...</div>
						</div>
					</div>
				</div>
			</div>
		</a-modal>
		<div v-if="editLoading">
			<edit-group :group_id="group_id" :visible="editLoading"  @cancel="cancel" @ok="ok"></edit-group>
		</div>
	</div>
</template>

<script>
	import editGroup from './editGroup.vue';
	import infiniteScroll from '@/common/directive';
	export default {
		directives: { infiniteScroll },
		components:{
			editGroup,
		},
		props: {
			filePathList: {
				type: Array,
				default: function() {
					return new Array;
				}
			},
			visible:{
				type:Boolean,
				default:false,
			},
			isPrivate:{
				type:Boolean,
				default:false,
			},
            isSingle:{
                type: Boolean,
                default: false,
            },
		},
		computed: {
			pics() {
				return this.value;
			}
		},
		created() {
			//console.log(this.value);
			this.getGroupList();
			this.getUploadTypeList();
		},
		data() {
			return {
				iconTypeList:['doc','docx','pdf'],
				fileTypeList:[],
				scrollLoading: false,
				busy: false,
				loading: false,
				editLoading: false,
				curSelectedList: {},
                curSelectedIdx: [],
				selectedList: [],
				group_id: 0,
				groupList: [],
				curGroupId: -1,
				moveGroupId: 0,
				fileList: [],
				page: 1,
				totalPage: 1,
			}
		},
		methods: {
			previewWord(item){
				let {href} = this.$router.resolve('/preview?file_type='+item.extension.toLowerCase()+'&file_path=' + item.file_path);
				//console.log(href);
				window.open(href, '_blank');
			},
			previewFile(item){
				let uploadTip = this.$message.loading('下载中,请稍等...', 0);
				this.$http.download('downloadFile', {id:item.file_id}).then(res=>{
					//console.log(res);
					uploadTip();
					this.showDownlaodLoading = false;
					var blob = new Blob([res.blob], {
						type: res.mime_type,
					});
					//新窗口打开
					let file = window.URL.createObjectURL(blob);
					window.open(file, '_blank');
				});
			},
			cancel(){
				this.editLoading=false;
			},
			ok(){
				this.editLoading=false;
				this.getGroupList();
				console.log('test');
			},
			resetFileList(){
				this.fileList = [];
				this.page = 1;
				this.totalPage = 1;
				this.handleInfiniteOnLoad();
				this.curSelectedList = {};
			},
			/**
			 * 取消弹窗
			 */
			handleCancel() {
				this.$emit("cancel");
			},
			handleOk(){
				this.$emit('ok', this.selectedList);
			},
			handleMoveGroup(){
				if(this.moveGroupId == 0){
					return ;
				}
				if(Object.keys(this.curSelectedList).length == 0){
					this.$message.error('请选择要移动的文件');
					return ;
				}
				this.$confirm({
					title:'您确定要移动文件至新的分组吗？',
					okText:"确定",
					okType:"danger",
					cancelText:"取消",
					onOk : ()=>{
						return new Promise((resolve,reject)=>{
							this.$http.api('platform/upload/moveFiles',{
								group_id: this.moveGroupId,
								file_ids: Object.keys(this.curSelectedList)
							}).then(res=>{
								this.$message.success('移动成功');
								this.resetFileList();
							}).catch(res=>{
								console.log(res);
							}).finally(()=>{
								resolve();
							})
						})
					}
				})
			},
			delFiles(){
				if(Object.keys(this.curSelectedList).length == 0){
					this.$message.error('请选择要删除的文件');
					return ;
				}
				this.$confirm({
					title:'您确定要删除选中的文件吗？',
					okText:"确定",
					okType:"danger",
					cancelText:"取消",
					onOk : ()=>{
						return new Promise((resolve,reject)=>{
							this.$http.api('platform/upload/deleteFiles',{
								file_ids: Object.keys(this.curSelectedList)
							}).then(res=>{
								this.$message.success('删除成功');
								this.resetFileList();
							}).catch(res=>{
								console.log(res);
							}).finally(()=>{
								resolve();
							})
						})
					}
				})
			},
			//添加分组
			add() {
				this.editLoading=true;
				this.group_id=0;
			},
			//编辑分组
			edit(item) {
				this.editLoading = true;
				this.group_id = item.group_id;
			},
			//删除分组
			del(item) {
				this.$confirm({
					title:'确定要删除当前分组吗？删除后分组下面的文件也将被删除!',
					okText:"确定",
					okType:"danger",
					cancelText:"取消",
					onOk : ()=>{
						return new Promise((resolve,reject)=>{
							this.$http.api('platform/upload/delGroup',{
								group_id: item.group_id,
							}).then(res=>{
								this.$message.success('删除成功');
								this.getGroupList();
							}).catch(res=>{
								console.log(res);
							}).finally(()=>{
								resolve();
							})
						})
					}
				})
			},
			handleChangeGroup(groupId){
				this.curGroupId = groupId;
				this.resetFileList();
			},
			//选中
			selected(item, index){
				if(item.selected){
					this.$set(item, 'selected', false);
					delete this.curSelectedList[item.file_id];
                    let idx = this.curSelectedIdx.indexOf(index);
                    this.curSelectedIdx.splice(idx, 1);
					this.getSelectedList();
					return  true;
				}
                if(this.isSingle){
                    this.curSelectedList = {};
                    if(this.curSelectedIdx.length > 0){
                        for(let i=0; i < this.curSelectedIdx.length; i++){
                            this.$set(this.fileList[this.curSelectedIdx[i]], 'selected', false);
                        }
                    }
                    this.curSelectedIdx = [];
                }
				this.$set(item, 'selected', true);
                this.curSelectedIdx.push(index);
				this.curSelectedList[item.file_id] = item;
				this.getSelectedList();
			},
			getSelectedList(){
				this.selectedList = [];
				if(Object.keys(this.curSelectedList).length<1){
					return false;
				}
				for(let key in this.curSelectedList){
					this.selectedList.push(this.curSelectedList[key]);
				}
			},
			getUploadTypeList(){
				this.$http.api('platform/upload/getUploadTypeList').then(res=>{
					if(res.type_list){
						this.fileTypeList = res.type_list;
					}
				}).catch(res=>{
					console.log(res);
				})
			},
			getGroupList(){
				this.$http.api('platform/upload/getGroupList').then(res=>{
					if(res.group_list){
						this.groupList = res.group_list;
					}
				}).catch(res=>{
					console.log(res);
				})
			},
			getFileList(){
				let isPrivate = this.isPrivate ? 1 : 0;
				this.$http.api('platform/upload/getFileList',{group_id: this.curGroupId, is_private:isPrivate, page: this.page}).then(res=>{
					if(res.data){
						this.totalPage = res.last_page;
						this.fileList = this.fileList.concat(res.data);
						this.page++;
						this.scrollLoading = false;
					}
				}).catch(res=>{
					console.log(res);
				})
			},
			
			handleInfiniteOnLoad() {
				console.log(this.page,this.totalPage);
				if(this.page > this.totalPage){
					this.busy =true;
					this.scrollLoading = false;
					return false;
				}
				this.busy = false;
				this.scrollLoading = true;
				this.getFileList();
			},

			upload(e) {
				let file = e.file;
				this.loading = true;
				let uploadTip = this.$message.loading('上传中,请稍等...', 0);
				this.$http.uploadFile(file, this.curGroupId, this.isPrivate).then(res => {
					uploadTip();
					this.$message.success('上传成功');
					this.loading = false;
					this.resetFileList();

				}).catch(res => {
					uploadTip();
					this.$message.error('上传出错了');
					this.loading = false;
				});
			},

			beforeUpload(file) {
				if(this.fileTypeList.indexOf(file.type)<0){
					this.$message.error('不支持的上传文件类型');
				}
				const isLt2M = file.size / 1024 / 1024 < 40;
				if (!isLt2M) {
					this.$message.error('文件最大为40M')
				}
				// if(this.value.length>=this.num){
				// 	this.$message.error('您上传的图片已达到'+this.num+'张')
				// }
				return isLt2M;
			},

			formatFloat(f, digit) {
				let m = Math.pow(10, digit);
				let num = Math.round(f * m) / m;
				return num;
			}

		},
	}
</script>

<style>
	::-webkit-scrollbar{ width: 6px; height: 6px;}
    ::-webkit-scrollbar-thumb{ border-radius:10px; background-color:#bdbdbd; -webkit-box-shadow:inset 0 0 6px rgba(0, 0, 0, 0.3);}
    *{scrollbar-color: #e5e5e5 #f7f7f9; scrollbar-width: thin;}
    a,a:hover{ text-decoration: none;}
	ul{list-style: none; margin:0; padding:0;}
	.box-wrap{ display: flex;}
    .group-box{ padding-top:6px; padding-bottom:30px; width: 150px; font-size:14px; min-height:35px;}
    .group-list{ overflow-y: auto; max-height:380px;}
    .group-list li{ position: relative; margin:3px 0; padding:8px 24px}
    .group-list li:hover,.group-list li.active{background:rgba(48, 145, 242, 0.1); border-radius:6px;}
	.group-list li span{ cursor: pointer;}
    .group-list li a{ color:#333;}
    .group-list li a.group-edit{ left:5px; display: none; position:absolute;}
    .group-list li a.group-delete{ right:5px; top:8px; display: none; position:absolute;}
    .group-list li.active a, .group-list li.active span, .group-list li:hover span,.group-list li:hover a, .group-list li:hover a:hover{color:#4772FF;}
    .group-list li:hover a{ display:block;}
    .group-box a.group-add{margin-top:10px; padding:0 24px; font-size:14px; color:#4772FF; display: block;}
    .file-box{ padding-top:10px; padding-bottom:10px; min-height:380px; flex:1; }
    .filter-tool{ margin-bottom:10px; padding:0 20px 0 10px; height: 32px; line-height: 32px; display:flex; justify-content: space-between;}
    .tool-box span.select-num,.tool-box a.delete-btn{ padding:0 10px; border:1px solid #EBEDF5;}
	.tool-box a.delete-btn{ border-left:none; color:rgba(0, 0, 0, 0.65);}
	.tool-box a.delete-btn:hover{ color:#4772FF;}
	.filter-tool .upload-btn{ border: 1px solid #4772FF; color:#4772FF;}
    .filter-tool .upload-btn:hover{color:#fff; background-color:#4772FF;}
	.file-list-box{ margin:0 auto; width:800px; position: relative;}
    .file-list-box ul.file-list{ height:390px; overflow-y:auto; display: flex; flex-wrap: wrap;}
    .file-list-box ul.file-list li {margin:8px; padding: 10px; width:120px; height:160px; position:relative;cursor:pointer;border-radius:6px;border:1px solid rgba(0, 0, 0, 0.05); box-sizing: content-box; -webkit-transition: All 0.2s ease-in-out;-moz-transition: All 0.2s ease-in-out;-o-transition: All 0.2s ease-in-out;transition: All 0.2s ease-in-out;}
    .file-list-box ul.file-list li:hover {border: 1px solid #4772FF; box-shadow:0 0 5px 0 #4772FF; }
    .file-list-box ul.file-list li .img-cover {width: 120px;height: 120px;background: no-repeat center center / 100%; text-align: center; position: relative; }
    .file-list-box ul.file-list li .file-cover{display: flex; align-items: center; justify-content: center;}
	.file-list-box ul.file-list li .file-icon{bottom:0px; right:0px; width:30px; height:30px; line-height:30px; text-align:center;background-color:rgba(0,0,0,0.6);border-top-left-radius:5px;  position: absolute;}
    .file-list-box ul.file-list li .file-icon .anticon{color:#fff;}
    .file-list-box ul.file-list li .font-icon{font-size:80px; color:rgba(0,0,0,0.35);}
	.file-list-box ul.file-list li p.file-name {margin: 5px 0 0 0;width: 120px;font-size: 1.3rem; }
    .file-list-box ul.file-list li .select-mask {position: absolute;top: 0;bottom: 0;left: 0;right: 0; display: flex; text-align:center; align-items: center; background: rgba(0, 0, 0, 0.5);text-align: center;border-radius: 6px;}
    .file-list-box ul.file-list li p.file-name{margin:5px 0 0 0; width:120px; line-height: 24px; font-size:12px; text-align:center!important; text-overflow:ellipsis; white-space:nowrap; overflow:hidden;}
	.file-list-box .loading-more{ 
		left:0; 
		bottom:-30px; 
		position:absolute;
		width: 100%;
		text-align: center;
	}
</style>
